import React, { useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { InlineLoader } from '../components/Loader';
import { getLogs } from '../utils/firestore';

export default function Logs() {
  const { currentUser } = useAuth();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getLogs(currentUser.uid).then(data => { setLogs(data); setLoading(false); });
  }, [currentUser]);

  const total = logs.reduce((s, l) => s + l.count, 0);

  if (selected) {
    return (
      <>
        <div className="topbar">
          <div>
            <div className="topbar-title">{selected.subject}</div>
            <div className="topbar-sub">
              Sent {selected.sentAt?.toDate ? selected.sentAt.toDate().toLocaleString() : '—'} · {selected.count} recipient{selected.count !== 1 ? 's' : ''} · from {selected.fromEmail || '—'}
            </div>
          </div>
          <button className="btn" onClick={() => setSelected(null)}>← Back to logs</button>
        </div>
        <div className="content">
          <div className="card">
            <div className="card-title">Recipients</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {(selected.recipients || []).map((r, i) => (
                <span key={i} className="tag">{r}</span>
              ))}
            </div>
          </div>
          <div className="card">
            <div className="card-title">Email preview</div>
            <div style={{ marginBottom: 12, fontSize: 13, color: 'var(--text2)' }}>
              <strong>From:</strong> {selected.fromName} &lt;{selected.fromEmail}&gt;<br />
              <strong>Subject:</strong> {selected.subject}
            </div>
            <div className="preview-frame" style={{ minHeight: 300 }}
              dangerouslySetInnerHTML={{ __html: selected.htmlBody || '<p style="color:#999">No email body saved</p>' }} />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">Send logs</div>
          <div className="topbar-sub">History of all emails sent from your account</div>
        </div>
      </div>
      <div className="content">
        <div className="stat-grid">
          <div className="stat-card"><div className="stat-label">Total sent</div><div className="stat-val">{total}</div></div>
          <div className="stat-card"><div className="stat-label">Credits used</div><div className="stat-val">{total}</div></div>
          <div className="stat-card"><div className="stat-label">Campaigns</div><div className="stat-val">{logs.length}</div></div>
        </div>
        <div className="card">
          <div className="card-title">Email history — click a row to view full email</div>
          {loading ? (
            <InlineLoader message="Loading send logs…" />
          ) : logs.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--text3)', fontSize: 13 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>📭</div>No emails sent yet
            </div>
          ) : (
            <table className="data-table">
              <thead>
                <tr><th>Time</th><th>Subject</th><th>From</th><th>Recipients</th><th>Count</th><th>Mode</th><th>Status</th></tr>
              </thead>
              <tbody>
                {logs.map(l => (
                  <tr key={l.id} onClick={() => setSelected(l)} style={{ cursor: 'pointer' }}>
                    <td style={{ color: 'var(--text3)', whiteSpace: 'nowrap' }}>{l.sentAt?.toDate ? l.sentAt.toDate().toLocaleString() : '—'}</td>
                    <td style={{ fontWeight: 500 }}>{l.subject}</td>
                    <td style={{ color: 'var(--text3)', fontSize: 12 }}>{l.fromEmail || '—'}</td>
                    <td style={{ color: 'var(--text3)' }}>{l.recipients?.slice(0, 2).join(', ')}{l.recipients?.length > 2 ? ` +${l.recipients.length - 2} more` : ''}</td>
                    <td>{l.count}</td>
                    <td><span className="badge badge-info">{l.mode}</span></td>
                    <td><span className={`badge badge-${l.status === 'sent' ? 'success' : 'danger'}`}>{l.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
}
